export default __webpack_public_path__ + "static/media/FromPortlandToPortland.ebe6c8da.JPG";